import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	MenuItem
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useState } from 'react'
import useSelectedFacility from '../../../hooks/useSelectedFacility'
import StyledSelect from '../../Common/StyledSelect'
import { addToDropoffPickupQueue } from '../../../actions/visits/visits.actions'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			width: '400px'
		}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '.8rem'
	},
	actionButtons: {
		justifyContent: 'flex-start',
		margin: 0,
		display: 'flex',
		gap: '.8rem'
	}
}))

const AddToDropoffPickupQueueDialog = ({ visit, isShown, onClose }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [selectedParkingSpot, setSelectedParkingSpot] = useState(-1)
	const [needsAssistanceWithDropoffMedications, setNeedsAssistanceWithDropoffMedications] = useState('unknown')
	const { facility } = useSelectedFacility()
	const facilityParkingSpots = facility?.parking_spots || []
	const isPickupScenario = visit?.pet_status?.every((pet) => pet.checked_in === true)
	const type = isPickupScenario ? 'pickup' : 'dropoff'
	const [loading, setLoading] = useState(false)

	const parkingSpotOptions = (() => {
		const opts = []
		for (const ps of facilityParkingSpots) {
			const { number } = ps
			opts.push({
				label: `${number}`,
				value: number
			})
		}
		opts.push({ label: 'Walk-up', value: 0 })
		return opts
	})()

	const handleSelectParkingSpot = (e) => {
		setSelectedParkingSpot(e?.target?.value >= 0 ? e?.target?.value : -1)
	}

	const handleNeedsAssistanceWithDropoffMedications = (e) => {
		setNeedsAssistanceWithDropoffMedications(e?.target?.value)
	}

	const handleOnClose = () => {
		setSelectedParkingSpot(-1)
		if (onClose) {
			onClose()
		}
	}

	const handleOnSave = async () => {
		setLoading(true)
		await addToDropoffPickupQueue(
			{
				visit_id: visit?._id,
				type,
				parking_spot: selectedParkingSpot,
				needs_assistance_with_dropoff_medications:
					needsAssistanceWithDropoffMedications === 'yes' ? true : false
			},
			dispatch
		)
		setLoading(false)
		handleOnClose()
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={handleOnClose}
			aria-labelledby="form-dialog-title">
			<DialogTitle>Add to I'm Here Queue</DialogTitle>
			<DialogContent style={{ margin: '24px 0px', overflow: 'visible' }}>
				<StyledSelect
					header="Select a Parking Spot or Walk-up"
					value={selectedParkingSpot}
					onChange={handleSelectParkingSpot}>
					{parkingSpotOptions.map(({ label, value }) => {
						return (
							<MenuItem key={`ps-${value}`} value={value}>
								{label}
							</MenuItem>
						)
					})}
				</StyledSelect>
				{type === 'dropoff' ? (
					<StyledSelect
						header="Did you bring any medications for this visit?"
						value={needsAssistanceWithDropoffMedications}
						onChange={handleNeedsAssistanceWithDropoffMedications}>
						{[
							{ label: 'Please select', value: 'unknown' },
							{ label: 'No', value: 'no' },
							{ label: 'Yes', value: 'yes' }
						].map(({ label, value }) => {
							return (
								<MenuItem key={`has-meds-${value}`} value={value}>
									{label}
								</MenuItem>
							)
						})}
					</StyledSelect>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<div className={classes.actionButtons}>
					<Button
						variant="contained"
						disabled={
							loading ||
							selectedParkingSpot < 0 ||
							(type === 'dropoff' && needsAssistanceWithDropoffMedications === 'unknown')
						}
						onClick={handleOnSave}
						color="secondary">
						{loading ? <CircularProgress /> : 'Save'}
					</Button>
					<Button variant="outlined" onClick={handleOnClose} color="secondary" disabled={loading}>
						Cancel
					</Button>
				</div>
			</DialogActions>
		</Dialog>
	)
}

export default AddToDropoffPickupQueueDialog
